import { useState } from "react";
import { Typography, Box } from "@mui/material";
import { ArrowForward, Lock } from "@mui/icons-material";
import ModalSM from "components/ModalSM";
import DivInline from "components/DivInline";
import LightIcon from "components/LightIcon";
import DivExist from "components/DivExist";
import SensorIcon from "components/SensorIcon";
import General from "@ecoenghk/general";
import Divider10 from "components/Divider10";
import IconButtonBack from "components/IconButtonBack";
const gs = new General();
export default function SensorLightSettingDisplayModal({
  children,
  sensorObj,
  lightObj,
}) {
  const [open, setOpen] = useState(false);
  const handleOpen = async () => {
    setOpen(true);
  };
  const lgSetting = sensorObj?.setting1?.[lightObj.serial];
  return (
    <>
      <div style={{ cursor: "pointer" }} onClick={handleOpen}>
        {children}
      </div>
      <ModalSM
        open={open}
        onClose={() => setOpen(false)}
        height="70vh"
        width="70vw"
      >
        <DivInline>
          <IconButtonBack onBtnClick={() => setOpen(false)} />
          <SensorIcon type={sensorObj?.type} disabledConnectStatus gang={sensorObj?.gang} width={3} sizeUnit="vw" />
          <Typography>{`Sensor ID: ${sensorObj?.sensorID}`}</Typography>
        </DivInline>
        <DivExist show={sensorObj?.type === "motion"}>
          <Divider10 />
          <Typography sx={{ marginLeft: "2vw" }}>{gs.dtkActionCmdToMsg(lgSetting, lightObj.serial)}</Typography>
          {/* <DivInline sx={{ margin: "2vw" }}>
            <SensorIcon
              type="motion"
              status={1}
              disabledConnectStatus
              width={4}
              sizeUnit="vw"
            />
            <Lock />
            <Typography>{lgSetting?.lockLevel}</Typography>
            <LightIcon
              disabledConnectStatus
              lightStyle={lightObj?.style}
              width={4}
              sizeUnit="vw"
              statusA={lgSetting?.onoffcontrolA}
              typeIsDim={lightObj?.type.pwm}
              lightLv={lgSetting?.pwm}
            />
            <ArrowForward sx={{ margin: "2vw" }} />
            <Typography>{lgSetting?.delayed_action}sec</Typography>
            <ArrowForward sx={{ margin: "2vw" }} />
            <LightIcon
              disabledConnectStatus
              lightStyle={lightObj?.style}
              width={4}
              sizeUnit="vw"
              statusA={lgSetting?.delayOnOff}
              typeIsDim={lightObj?.type.pwm}
              lightLv={lgSetting?.delayedPwm2}
            />
            <DivExist show={lgSetting?.delayed_action2 > 0}>
              <ArrowForward sx={{ margin: "2vw" }} />
              <Typography>{lgSetting?.delayed_action2}sec</Typography>
              <ArrowForward sx={{ margin: "2vw" }} />
              <LightIcon
                disabledConnectStatus
                lightStyle={lightObj?.style}
                width={4}
                sizeUnit="vw"
                statusA={lgSetting?.delayOnOff2}
                typeIsDim={lightObj?.type.pwm}
                lightLv={lgSetting?.delayedPwm2}
              />
            </DivExist>
            <Lock />
            <Typography>
              {lgSetting?.releaseOnDelayEnd ? 5 : lgSetting?.lockLevel}
            </Typography>
            <SensorIcon
              type="motion"
              status={0}
              disabledConnectStatus
              width={4}
              sizeUnit="vw"
            />
          </DivInline> */}
        </DivExist>
        <DivExist show={sensorObj?.type === "daylight"}>
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n, key) => {
            const lgSetting =
              sensorObj?.[`setting${n + 1}`]?.[lightObj?.serial];
            return (
              <DivInline key={key}>

                <Typography sx={{ marginLeft: "2vw" }}>{gs.dtkActionCmdToMsg(lgSetting, lightObj.serial)}</Typography>
                {/* <SensorIcon
                  type="daylight"
                  luxLv={n}
                  disabledConnectStatus
                  width={3}
                  sizeUnit="vw"
                />
                {n === 10 ? (
                  <Typography
                    sx={{ width: "11vw" }}
                    variant="caption"
                  >{`Lv10. >1000lux`}</Typography>
                ) : (
                  <Typography sx={{ width: "11vw" }} variant="caption">
                    {`Lv${n}.  ${n * 100}-${n * 100 + 99}`}lux
                  </Typography>
                )}
                <Lock />
                <Typography>{lgSetting?.lockLevel}</Typography>
                <ArrowForward sx={{ margin: "1vw" }} />
                <LightIcon
                  disabledConnectStatus
                  lightStyle={lightObj.style}
                  width={3}
                  sizeUnit="vw"
                  statusA={lgSetting?.pwm > 0 ? 0 : 1}
                  typeIsDim={lightObj.type.pwm}
                  lightLv={lgSetting?.pwm}
                />
                <Typography>{lgSetting?.pwm}%</Typography>
                <ArrowForward sx={{ margin: "1vw" }} />
                <Lock />
                <Typography>
                  {lgSetting?.releaseOnDelayEnd ? 5 : lgSetting?.lockLevel}
                </Typography> */}
              </DivInline>
            );
          })}
        </DivExist>
        <DivExist show={sensorObj?.type === "scenebutton"}>
          {
            gs.newArrayBetween(1, (sensorObj.gang || 1)).map(n => {
              let cmd = gs.dtkActionCmdToMsg(sensorObj[`setting${n}`]?.[lightObj.serial], lightObj.serial)
              if (lightObj.serial in (sensorObj?.[`setting${n}`] || {}) === false) cmd = "No setting"
              return (
                <Box key={n}>
                  <Typography>Button {n}</Typography>
                  <Typography sx={{ marginLeft: "2vw" }}>{cmd}</Typography>
                  <Divider10 />
                </Box>
              )
            })
          }

        </DivExist>
      </ModalSM>
    </>
  );
}
